module.exports = __webpack_public_path__ + "img/eplogo-horizontal-grid.10d40b8e.svg";